import LabeledInput, { LabeledInputProps } from 'components/form/input';

type Props = Omit<LabeledInputProps, 'type'>;

const Password = (props: Props) => (
  <LabeledInput togglePassword {...props} type="password" />
);

export default Password;
